/* eslint-disable security/detect-object-injection */
import Vue from 'vue';
import Vuex from 'vuex' ;
import { util, ConfigService } from '@nuskin/ns-util';
import { UserService } from '@nuskin/ns-account';
import translation from './modules/translation';
import account from './modules/account';
import huTax from './modules/huTax';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state:{
        mobileView: util.MobileUtils.isMobileLike(),
        displayName : '',
        preferredName: '',
        profilePic:'',
        marketConfig: ConfigService.getMarketConfig().mecSite,
        siteConfig: ConfigService.getMarketConfig(),
        allowThirdGender:false,
        isEmailVerified: false,
        isEmailSentHavingIssue: false,
        isResendVerifyEmail: false,
        isEmailCardShowing: false,
        isUsernameStatus: true,
        isModified: false,
        isPendingStatus: false,
        username: '',
        pendingUsername: '',
        errorMsg: ''
    },
    getters:{
        mobileView : state => {
            return state.mobileView;
        },
        displayName: state => {
            return state.displayName;
        },
        preferredName: state => {
            return state.preferredName;
        },
        profilePic: state => {
            return state.profilePic;
        },
        marketConfig : state => {
            return state.marketConfig
        },
        marketConfigBooleanByName: (state, getters) => (id) => {
            return state.marketConfig[id] === 'false' ? false : !!state.marketConfig[id];
        },
        siteConfig : state => {
            return state.siteConfig
        },
        allowThirdGender : state => {
            return state.allowThirdGender
        },
        isEmailVerified: state => {
            return state.isEmailVerified
        },
        isEmailSentHavingIssue: state => {
            return state.isEmailSentHavingIssue
        },
        isResendVerifyEmail: state => {
            return state.isResendVerifyEmail
        },
        isEmailCardShowing: state => {
            return state.isEmailCardShowing
        },
        isUsernameStatus: state => {
            return state.isUsernameStatus
        },
        isModified: state => {
            return state.isModified
        },
        getUsername: state => {
            return state.username
        },
        isPendingStatus: state => {
            return state.isPendingStatus
        },
        pendingUsername: state => {
            return state.pendingUsername
        },
        errorMsg: state => {
            return state.errorMsg
        }
    },
    mutations : {
        updateDisplayName: (state, payload) => {
            let user = UserService.getUser();
            let name = payload
                || user.displayName
                || user.localName
                || user.lastName + ', ' + user.firstName;
            state.displayName = name;
        },
        updatePreferredName: (state, payload) => {
            state.preferredName = payload;
        },
        updateProfilePic: (state, payload) => {
            state.profilePic = payload;
        },
        updateAllowThirdGender: (state, payload) => {
            state.allowThirdGender = payload;
        },
        setEmailVerified: (state, payload) => {
            state.isEmailVerified = payload
        },
        setEmailSentHavingIssue: (state, payload) => {
            state.isEmailSentHavingIssue = payload
        },
        setResendVerifyEmail: (state, payload) => {
            state.isResendVerifyEmail = payload
        },
        setEmailCardShowing: (state, payload) => {
            state.isEmailCardShowing = payload
        },
        setUsernameStatus: (state, payload) => {
            state.isUsernameStatus = payload
        },
        setModified: (state, payload) => {
            state.isModified = payload
        },
        setUsername: (state, payload) => {
            state.username = payload
        },
        setPendingStatus: (state, payload) => {
            state.isPendingStatus = payload
        },
        setPendingUsername: (state, payload) => {
            state.pendingUsername = payload
        },
        setErrorMsg: (state, payload) => {
            state.errorMsg = payload
        }
    },
    actions :{
        updatePreferredName: ({commit}, payload) => {
            commit('updatePreferredName', payload);
            // We need to update the displayName with either the newly updated PreferredName or the existing name
            commit('updateDisplayName', payload);
        },
        updateProfilePic: ({commit}, payload) => {
            commit('updateProfilePic', payload);
        },
        updateAllowThirdGender: ({commit}, payload) => {
            commit('updateAllowThirdGender', payload);
        },
        setEmailVerified: ({commit}, payload) => {
            commit('setEmailVerified', payload);
        },
        setEmailSentHavingIssue: ({commit}, payload) => {
            commit('setEmailSentHavingIssue', payload);
        },
        setResendVerifyEmail: ({commit}, payload) => {
            commit('setResendVerifyEmail', payload);
        },
        setEmailCardShowing: ({commit}, payload) => {
            commit('setEmailCardShowing', payload);
        },
        setUsernameStatus: ({commit}, payload) => {
            commit('setUsernameStatus', payload);
        },
        setModified: ({commit}, payload) => {
            commit('setModified', payload);
        },
        setUsername: ({commit}, payload) => {
            commit('setUsername', payload);
        },
        setPendingStatus: ({commit}, payload) => {
            commit('setPendingStatus', payload);
        },
        setPendingUsername: ({commit}, payload) => {
            commit('setPendingUsername', payload);
        },
        setErrorMsg: ({commit}, payload) => {
            commit('setErrorMsg', payload);
        }
    },
    modules:{
        translation,
        account,
        huTax
    }

});
